import React from 'react';
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText
} from '@mui/material';

export const BasicInfoSection = ({ 
  formik, 
  loading, 
  hasError, 
  getErrorMessage,
  statusOptions 
}) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          fullWidth
          id="name"
          name="name"
          label="Job Name"
          variant="outlined"
          required
          value={formik.values.name}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={hasError(formik, 'name')}
          helperText={getErrorMessage(formik, 'name')}
          disabled={loading}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          fullWidth
          id="description"
          name="description"
          label="Description"
          variant="outlined"
          multiline
          rows={2}
          value={formik.values.description}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          disabled={loading}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth>
          <InputLabel id="status-label">Status</InputLabel>
          <Select
            labelId="status-label"
            id="status"
            name="status"
            value={formik.values.status}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            label="Status"
            error={hasError(formik, 'status')}
            disabled={loading}
          >
            {statusOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
          {hasError(formik, 'status') && (
            <FormHelperText error>{getErrorMessage(formik, 'status')}</FormHelperText>
          )}
        </FormControl>
      </Grid>
    </Grid>
  );
};